<template>
  <div>
    <eden-page-stats
      class="mt-0"
      :title="'Overview'"
      :loading="loading"
      :stats="stats"
      :show-periods="true"
      :periods="periods"
      :show-custom-period="true"
      @set-period="getGardenRewardsData"
    />
    <eden-table-actions :title="title" @search="search">
      <template
        slot="actions"
        v-if="allowAccessFor(['admin', 'growth', 'gardener_pro'])"
      >
        <garden-rewards-filter
          :disabled="loading"
          :clear="filterParams.clear"
          @filter="filter"
          class="mr-1"
        />
        <GardenRewardsExport :data="pageData" :search="searchQuery" />
      </template>
    </eden-table-actions>
    <eden-loader v-if="loading" />
    <template v-else>
      <eden-filter-items
        v-if="filterParams.status"
        :params="filterParams.paramsLabel"
        @clear-filter="clearFilter"
        @clear-filters="clearFilters"
      />
      <template v-if="pageData.length">
        <el-table :data="pageData">
          <el-table-column width="200">
            <template #header>
              <eden-table-column-header
                :label="'Name'"
                :property="'name'"
                :sort-property="sort.property"
                @sort="sortPageData($event, 'name')"
              />
            </template>
            <template v-slot="scope">
              <router-link
                :to="{
                  name: 'customers.individual',
                  params: { id: scope.row.id },
                }"
              >
                <span class="font-sm text-primary">
                  {{ formatName(scope.row.name) }}</span
                ></router-link
              >
              <span class="font-xsm"> {{ scope.row.email }} </span>
            </template>
          </el-table-column>
          <el-table-column>
            <template #header>
              <eden-table-column-header
                :label="'Apples Earned'"
                :property="'apples_earned_count'"
                :sort-property="sort.property"
                @sort="sortPageData($event, 'apples_earned_count')"
              />
            </template>
            <template v-slot="scope">
              <span>{{ scope.row.apples_earned_count }}</span>
            </template>
          </el-table-column>
          <el-table-column>
            <template #header>
              <eden-table-column-header
                :label="'Apples Redeemed'"
                :property="'apples_redeemed_count'"
                :sort-property="sort.property"
                @sort="sortPageData($event, 'apples_redeemed_count')"
              />
            </template>
            <template v-slot="scope">
              <span>{{ scope.row.apples_redeemed_count }}</span>
            </template>
          </el-table-column>
          <el-table-column>
            <template #header>
              <eden-table-column-header
                :label="'Referred Signups'"
                :property="'referred_signups_count'"
                :sort-property="sort.property"
                @sort="sortPageData($event, 'referred_signups_count')"
              />
            </template>
            <template v-slot="scope">
              <span>{{ scope.row.referred_signups_count }}</span>
            </template>
          </el-table-column>
          <el-table-column width="150">
            <template #header>
              <eden-table-column-header
                :label="'Referred Subscribers'"
                :property="'referred_subscribers_count'"
                :sort-property="sort.property"
                @sort="sortPageData($event, 'referred_subscribers_count')"
              />
            </template>
            <template v-slot="scope">
              <span>{{ scope.row.referred_subscribers_count }}</span>
            </template>
          </el-table-column>
          <el-table-column>
            <template #header>
              <eden-table-column-header
                :label="'Status'"
                :property="'customer_status'"
                :sort-property="sort.property"
                @sort="sortPageData($event, 'customer_status')"
              />
            </template>
            <template v-slot="scope">
              <span class="font-sm table--status">
                <el-tag :type="setType(scope.row.customer_status)">
                  {{ formatText(scope.row.customer_status) }}
                </el-tag>
              </span>
            </template>
          </el-table-column>
          <el-table-column width="180">
            <template v-slot="scope">
              <router-link
                class="rewards"
                :to="{
                  name: 'customers.individual.rewards',
                  params: { id: scope.row.id },
                }"
                >Open rewards profile</router-link
              ></template
            >
          </el-table-column>
        </el-table>
        <eden-pagination
          v-if="showPagination"
          :from="pagination.from"
          :to="pagination.to"
          :total="pagination.total"
          :current-page.sync="page"
        />
      </template>
      <eden-content-empty v-else :text="'No Garden Users'" />
    </template>
  </div>
</template>

<script>
import GardenRewardsExport from "./GardenRewardsExport.vue";
import GardenRewardsFilter from "./GardenRewardsFilter.vue";
import rewards from "@/requests/discounts/rewards";

export default {
  name: "GardenRewardsCentreData",
  components: {
    GardenRewardsFilter,
    GardenRewardsExport,
  },
  data() {
    return {
      loading: false,
      page: 1,
      pagination: {
        from: null,
        to: null,
        total: null,
      },
      sort: {
        property: "name",
        direction: "asc",
      },
      pageData: [],
      showPagination: true,
      periods: {
        today: "Today",
        tomorrow: "Tomorrow",
        thisweek: "This week",
      },
      custom: {
        from: null,
        to: null,
      },
      stats: [
        {
          label: "Total referred signups",
          figure: 0,
        },
        {
          label: "Total referred subscribers",
          figure: 0,
        },
        {
          label: "Total apples redeemed",
          figure: 0,
        },
      ],
      filterParams: {
        clear: false,
        status: false,
        params: {},
        paramsLabel: {},
      },
      searchQuery: "",
    };
  },
  computed: {
    discounts() {
      return this.$store.getters.discounts;
    },
    title() {
      const total = this.pagination.total;
      const result = this.pageData.length;
      const value = (this.showPagination ? total : result) || 0;
      return `${value} Garden User${value > 1 ? "s" : ""}`;
    },
  },
  watch: {
    page() {
      if(this.filterParams.status) {
        this.filter({
          params: this.filterParams.params,
          paramsLabel: this.filterParams.paramsLabel,
        });
      } else {
        this.getGardenRewardsData({
          period: this.period,
          from: this.custom.from,
          to: this.custom.to,
        });
      }
    },
  },
  created() {
    this.getGardenRewardsData({ period: "today" });
  },
  methods: {
    sortPageData(direction, property) {
      this.sort = { property, direction };
      this.pageData = this.sortList(this.pageData, property, direction);
    },
    getGardenRewardsData({ period, from, to }) {
      const { start_date, end_date } = this.formatStartAndEndDate({
        period,
        from,
        to,
      });

      this.loading = true;
      const params = `?page=${this.page}&start_date=${start_date}&end_date=${end_date}`;

      rewards
        .fetchGardenUsers(params)
        .then((response) => {
          const { status, data } = response.data;

          if (status) {
            this.stats[0].figure = data.summary.referred_signups;
            this.stats[1].figure = data.summary.referred_subscribers;
            this.stats[2].figure = data.summary.redeemed_rewards;
            this.pageData = data.customers.data;
            this.pagination.from = data.customers.from;
            this.pagination.to = data.customers.to;
            this.pagination.total = data.customers.total;
            this.showPagination = true;
          }
        })
        .catch((error) => {
          this.loading = false;
          const errorMessage = error.response.data;
          if (errorMessage.errors) {
            const errorKeys = Object.keys(errorMessage.errors);
            this.$message.error(errorMessage.errors[errorKeys[0]].join(""));
          } else {
            this.$message.error(errorMessage.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    search(query) {
      this.searchQuery = query;
      if (query === "") {
        this.getGardenRewardsData();
        return;
      }
      this.loading = true;
      rewards
        .fetchGardenUsers(`?query=${query}`)
        .then((response) => {
          if (response.data.status) {
            this.stats[0].figure = response.data.data.summary.referred_signups;
            this.stats[1].figure =
              response.data.data.summary.referred_subscribers;
            this.stats[2].figure = response.data.data.summary.redeemed_rewards;
            this.pageData = response.data.data.customers.data;
            this.showPagination = false;
          }
        })
        .catch((error) => {
          this.loading = false;
          const errorMessage = error.response.data;
          if (errorMessage.errors) {
            const errorKeys = Object.keys(errorMessage.errors);
            this.$message.error(errorMessage.errors[errorKeys[0]].join(""));
          } else {
            this.$message.error(errorMessage.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    filter({ params, paramsLabel }) {
      console.log(params, paramsLabel);

      const apiParams = `?page=${this.page}`;
      this.loading = true;

      rewards
        .filterGardenUsers(params, apiParams)
        .then((response) => {
          const { status, data } = response.data;

          if (status) {
            this.filterParams = {
              status: true,
              params: params,
              paramsLabel: paramsLabel,
            };

            this.pageData = data.data;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
            this.pagination.total = data.total;
            this.showPagination = true;
          }
        })
        .catch((error) => {
          this.loading = false;
          const errorMessage = error.response.data;
          if (errorMessage.errors) {
            const errorKeys = Object.keys(errorMessage.errors);
            this.$message.error(errorMessage.errors[errorKeys[0]].join(""));
          } else {
            this.$message.error(errorMessage.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clearFilter(key) {
      delete this.filterParams.params[key];
      delete this.filterParams.paramsLabel[key];

      const keys = this.filterParams.params;

      if (Object.keys(keys).length) {
        this.filter({
          params: this.filterParams.params,
          paramsLabel: this.filterParams.paramsLabel,
        });
      } else {
        this.getGardenRewardsData({ period: "today" });
      }
    },
    clearFilters() {
      this.getGardenRewardsData({ period: "today" });
      this.filterParams = {
        clear: true,
        status: false,
        params: {},
        paramsLabel: {},
      };
    },
  },
};
</script>

<style lang="postcss" scoped>
.rewards {
  display: inline-block;
  margin: 5px 0;
  font-size: 0.775rem;
  color: var(--eden-green-primary);
  border-bottom: 1px solid var(--eden-green-primary);
}
</style>
